import { 
    View, Text, Image,
} from 'react-native';
import { useNavigate } from 'react-router-dom';
import { FONT } from '../../value/staticValues';
import { CustomConfirmBtn } from '../base/CustomConfirmBtn';

// const images = {
//     // 기본 아이콘
//     ico_fornax_bi_wh: require("../../img/ico-fornax-bi-wh.png"),
//     ico_page_error: require("../../img/ico-page-error.png"),
//     ico_ci_grey: require("../../img/ico-ci-grey.png"),
// }


export default function NotFound() {
    const navigate = useNavigate();

    return (
        <View style={{minWidth: 1920, minHeight: "100vh"}}>
            <View style={{
                flexDirection: "row", alignItems: "center",
                minWidth: 1920, height: 66,
                paddingLeft: 68, paddingRight: 40,
                backgroundColor: "#7066f1"
            }}>
                {/* <Image style={{ width: 140, height: 28, marginRight: "auto" }} source={images.ico_fornax_bi_wh}/> */}
            </View>
            <View style={{
                alignItems: "center", justifyContent: "center",
                minHeight: 1300,
            }}>
                <Text style={{
                    fontFamily:FONT.MEDIUM,
                    fontSize:36,
                    color: "#7066f1"
                }}>
                    Sorry, This page Can't be found.
                </Text>
                {/* <Image source={images.ico_page_error} style={{width:301, height: 200, marginTop: 44, marginBottom: 9}}/> */}
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 14, 
                    lineHeight: 24,
                    color: "#333",
                    textAlign: "center",
                }}>
                    요청하신 페이지를 찾을 수 없습니다.<br/>
                    페이지의 주소를 잘못 입력하셨거나, 주소가 변경 혹은 삭제되었을 수 있습니다.
                </Text>
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 14, 
                    lineHeight: 24,
                    color: "#323ebd"
                }}>
                    입력하신 주소를 다시 한번 확인해주세요.
                </Text>
                <View style={{
                    flexDirection: "row", alignItems: "center",
                    marginTop: 40
                }}>
                    {/* <CancelButton
                        text={"이전으로"}
                        size={{
                            width: 120,
                            height: 40
                        }}
                        fontsize={13}
                        onPress={() => {
                            navigate(-1);
                        }}
                    /> */}
                    <View style={{width: 10}}/>
                    <CustomConfirmBtn
                        text={"메인으로"}
                        size={{
                            width: 120,
                            height: 40
                        }}
                        fontsize={13}
                        onPress={() => {
                            navigate(`/`);
                        }}
                    />
                </View>
                {/* <Image source={images.ico_ci_grey} style={{width: 112, height: 15, marginTop: 156, marginBottom: 15}}/> */}
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    color: "#b1b1b1"
                }}>
                    Copyright ⓒ FornaX. All Rights Reserved.
                </Text>
            </View>
        </View>
    );
}